/**
 * Exporta linhas como CSV e dispara o download no navegador — sem
 * dependência nova, só `Blob`/`URL.createObjectURL`. BOM no início para o
 * Excel abrir acentuação em português corretamente.
 */
export function exportarCsv(nomeDoArquivo: string, cabecalhos: string[], linhas: string[][]): void {
  const BOM = '﻿';
  const escapar = (valor: string): string => {
    if (valor.includes(',') || valor.includes('"') || valor.includes('\n')) {
      return `"${valor.replace(/"/g, '""')}"`;
    }
    return valor;
  };
  const conteudo = [
    cabecalhos.map(escapar).join(','),
    ...linhas.map((linha) => linha.map((celula) => escapar(celula ?? '')).join(',')),
  ].join('\r\n');

  const blob = new Blob([BOM + conteudo], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = nomeDoArquivo;
  link.click();
  URL.revokeObjectURL(url);
}
